import React, {useEffect} from 'react';
import { ThemeProvider } from '@mui/material/styles';
import MainLayout from 'router';
import CssBaseline from '@mui/material/CssBaseline';
import GlobalStyles from '@mui/material/GlobalStyles';
import globalStyles from 'common/styles/global-styles';
import { createTheme } from '@mui/material/styles';
import lightPalette from 'common/styles/palette-light';
import darkPalette from 'common/styles/palette-dark';
import overwrite from 'common/styles/overwrite';
import ColorModeContext from 'common/color-mode-context';
import useThemeDetector from './common/utils/theme-detector';
import { THEME } from 'common/constants/local-storage';


const App = () => {
  const isDarkTheme = useThemeDetector();
  const [mode, setMode] = React.useState(localStorage.getItem(THEME));
  const colorMode = React.useMemo(
    () => ({
      toggleColorMode: () => {
        setMode(prevMode => {
          const currentMode = (prevMode === 'light' ? 'dark' : 'light');
          localStorage.setItem(THEME, currentMode);
          return currentMode;
        });
      },
    }),
    [],
  );
  
  useEffect(() => {
    if(!localStorage.getItem(THEME)) {
      setMode( isDarkTheme ? 'dark' : 'light')
    }
  }, [isDarkTheme]);
  
  const theme = React.useMemo(() => {
    const palette = mode === 'light' ? lightPalette : darkPalette;
    return createTheme({
      spacing: 2,
      direction: 'ltr',
      palette,
      components: overwrite(palette),
    });
  },[mode]);
  
  return(
    <ColorModeContext.Provider value={colorMode}>
      <ThemeProvider theme={theme}>
        <CssBaseline/>
        <GlobalStyles styles={globalStyles} />
        <MainLayout />
      </ThemeProvider>
    </ColorModeContext.Provider>
  );
};


export default App;
